import React, { useState, useEffect } from 'react';
import './index.less';
import apis from '../../../../apis';
import { Statistic, Empty } from '@drip/drip-design';
import { Chart, LineAdvance, Legend } from 'bizcharts';
import { TREND_INDICATORS } from './constant';
import IconTip from '@/components/icon-tip';
import NumberFormate from './common';

const funelIndicator = [
  'search_expose_item_qtty',
  'search_click_item_qtty',
  'search_ord_deal_ord_item_qtty',
  'search_ord_out_ord_item_qtty',
];

const FunelAndTrend = (props) => {
  const { conditions, indicators, showDlg } = props;

  const [funelData, setFunelData] = useState([
    { mark: 'expo', value: 'search_expose_item_qtty', title: '曝光', subTitle: '曝光商品数', number: 0 },
    { mark: 'clk', value: 'search_click_item_qtty', title: '点击', subTitle: '点击商品数', number: 0 },
    { mark: 'deal', value: 'search_ord_deal_ord_item_qtty', title: '成交', subTitle: '成交商品数', number: 0 },
    { mark: 'out', value: 'search_ord_out_ord_item_qtty', title: '出库', subTitle: '出库商品数', number: 0 },
  ]);

  const [trendData, setTrendData] = useState([]);

  useEffect(() => {
    let funelParam = {
      ...conditions,
      indicators: funelIndicator,
      modelId: '0001ce7f-1839-4c01-8c38-f2057e0e9670',
      orders: {},
    };

    if (conditions.criteria) {
      apis.platDataOneServiceQuery(funelParam).then((res) => {
        // console.log('漏斗图', res);
        const list = res?.data?.bos;
        const arr = funelData;
        if (list && list.length) {
          arr.map((item) => {
            //千分位绝对值取整
            let number = list[0][item.value] ? NumberFormate(item.value, list[0][item.value]) : 0;
            item.number = number;
          });
          setFunelData(arr);
        }
      });
    }
  }, [conditions, funelData]);

  useEffect(() => {
    let trendParam = {
      ...conditions,
      indicators: indicators,
      modelId: '93aa266b-418a-441f-a7eb-c17ab5c3e05a',
      orders: {},
    };
    if (conditions.criteria && !showDlg) {
      apis.platDataOneServiceQuery(trendParam).then((res) => {
        // console.log('趋势图', res);
        const list = res?.data?.bos;
        const arr = [];
        if (list && list.length) {
          list.map((item) => {
            indicators.map((i) => {
              let number = item[i] ? NumberFormate(i, item[i], 'trend') : 0;
              let obj = {
                date: item.dt,
                number: number,
                type: TREND_INDICATORS[i],
              };
              arr.push(obj);
            });
          });

          setTrendData(arr);
        } else {
          setTrendData();
        }
      });
    }
  }, [conditions, indicators, showDlg]);

  //千分位数值
  const numberFormate = (num) => {
    let reg = /\B(?=(\d{3})+$)/g;
    return String(num).replace(reg, ',');
  };
  const scale = {
    number: {
      min: 0,
      //   formatter(val) {
      //     return numberFormate(val);
      //   },
    },
  };

  return (
    <div className="funnel-and-trend">
      <div className="funnel-con">
        <div className="con-title">
          商品漏斗图 <IconTip title={'时间查询多天时，页面指标显示平均值'} />
        </div>
        <div className="funel-chart">
          {funelData.map((item, index) => {
            return (
              <div className={`funel-chart-item ${item.mark}`} key={'funel-chart-item' + index}>
                <div className="item-title">{item.title}</div>
                <div className="item-detail">
                  <Statistic className="item-number" title={item.subTitle} value={item.number} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="trend-con">
        <div className="con-title">趋势图</div>
        {trendData ? (
          <div className="trend-chart">
            <Chart data={trendData} height={290} padding="auto" autoFit scale={scale}>
              <Legend
                name="type"
                layout="horizontal"
                background={{
                  padding: [10, 10, 10, 0],
                  style: {
                    stroke: '#fff',
                    lineWidth: 0,
                  },
                }}
                position="top-left"
              />
              <LineAdvance
                shape="smooth"
                position="date*number"
                color={['type', ['#007AFF', '#59D022', '#2BD1C3', '#02B7FF']]}
              />
            </Chart>
          </div>
        ) : (
          <div className="flow-empty">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </div>
    </div>
  );
};

export default FunelAndTrend;
